import React, { Component } from "react";
import {Link, withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import {FormattedMessage} from 'react-intl'
import HtmlSection from './htmlsection';
import * as wActs from "../actions/website-actions";

class Footer extends Component {

  handleClick(e) {
    eval('$("html, body").animate({scrollTop: "0px"}, 800)');
    //return true;
  }

  getRequestInfo() {
    if(this.props.WebPage.Request) {
      let req = this.props.WebPage.Request;
      return (<span>{req.IpAddress} - [{req.CountryCode}]</span>)
    } else {
      return null;
    }
  }


  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  handleRefresh(e) {
    e.preventDefault();
    window.location.reload(true) //Force cache update fuckers
  }

  render() {
    let ihme = this.props.WebPage.Page.Name === "Home";
    let mob = this.props.WebPage.Device.IsMobileDevice;
    return (
      <footer>
        <div className="container">
          <div className="logo">
            <Link to={wActs.getCultPath(this.props.WebPage,"/")}><img src={this.props.WebPage.Settings.LogoUrl} alt={this.props.WebPage.Settings.SeoName}/></Link>
          </div>
          <div className="menu">
            <nav>
              {!wActs.isNullOrUndefined(this.props.WebPage.Menu.Footer) &&
              <ul>
                {this.props.WebPage.Menu.Footer.map((v,i) => {
                  if(!ihme && (v.Name=="Terms" || v.Name=="Privacy" || v.Name=="Sitemap")) return null;
                  if(v.Page) {
                    return <li key={"mnuli" + i} onClick={(e) => { this.handleClick(e) }}><Link className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} to={v.Page.Path} title={v.Description}>{v.Title}</Link></li>;
                  } else {
                    if(v.Settings) {
                      return <li key={"mnuli" + i} onClick={(e) => { this.handleClick(e) }}><a className={this.props.WebPage.Settings.LocalCSS} key={"mnu" + i} href={v.Settings.Url} target="_blank" title={v.Description}>{v.Title}</a></li>;
                    }
                  }
                  return null;
                })}
              </ul>
              }
            </nav>
          </div>
          {mob &&
          <div className="socials">
            <ul>
              {!wActs.isNullOrEmpty(this.props.WebPage.Settings.TwitterUrl) &&
              <li><a href={this.props.WebPage.Settings.TwitterUrl} target="_blank" style={{background: "#00acee"}}><i className="fab fa-twitter"></i></a></li>
              }
              {!wActs.isNullOrEmpty(this.props.WebPage.Settings.FacebookUrl) &&
              <li><a href={this.props.WebPage.Settings.FacebookUrl} target="_blank" style={{background: "#3b5998"}}><i className="fab fa-facebook-f"></i></a></li>
              }
              {!wActs.isNullOrEmpty(this.props.WebPage.Settings.InstagramUrl) &&
              <li><a href={this.props.WebPage.Settings.InstagramUrl} target="_blank" style={{background: "#F44747"}}><i className="fab fa-instagram"></i></a></li>
              }
              {!wActs.isNullOrEmpty(this.props.WebPage.Settings.TelegramUrl) &&
              <li><a href={this.props.WebPage.Settings.TelegramUrl} target="_blank" style={{background: "#0088cc"}}><i className="fab fa-telegram-plane"></i></a></li>
              }
            </ul>
          </div>
          }
          <div className="copyright">
            {(!wActs.isNullOrUndefined(this.props.WebPage.Page.Content.LiabilityWarning)) &&
            <p style={{margin: "20px auto", maxWidth: "820px"}}><span>{this.props.WebPage.Page.Content.LiabilityWarning}</span></p>
            }
            <p><FormattedMessage id={"page.footer.copyright"} /></p>
            <p><FormattedMessage id={"page.footer.allmodelslistedwarning"}/></p>
            <p><FormattedMessage id={"page.footer.version"}/> - [<a onClick={(e) => {this.handleRefresh(e)}} style={{cursor: 'pointer', fontSize: "12px", textTransform: 'none', color: "white"}}><FormattedMessage id={"page.refresh"}/></a>]</p>
            {(this.props.WebPage.Settings.ShowCompanyInfoInFooter && !wActs.isNullOrUndefined(this.props.WebPage.Page.Content.CompanyInfoFooter)) &&
              <p>{this.props.WebPage.Page.Content.CompanyInfoFooter}</p>
            }
          </div>
          <div className="flex-center mt">
            <HtmlSection Id="DMCA"/>
          </div>
          <div style={{minHeight: "100px", display: "block", width: "100%"}}>&nbsp;</div>
        </div>
      </footer>
  );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website
  };
}

export default connect(mapStateToProps)(Footer);
